'use strict'

module.exports = () => ({
  isValidContext: () => false
})



// WEBPACK FOOTER //
// ./components/adapters/nullAdapter.js